import { Component } from "react";
import { Button, Col, Container } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Table from "react-bootstrap/Table";
import Laoding from "../../../../components/Loading";
import PaginateCard from "../../../../components/PaginateCard";
import PrintLink from "../../../../components/Shipment/Factor/PrintLink";
import DateFilter from "../../../../components/tools/DateFilter";
import ExcelDownload from "../../../../components/tools/ExcelDownload";
import { getRequestByAuth } from "../../../../function/helper";
import styles from "./transactionTableList.module.css";

export default class TransactionTablePage extends Component {
  state = {
    users: [],
    showNumber: 10,
    pageNumber: 1,
    searchText: "",
    active: 1,
    items: [],
    paginationlength: 1,
    startNumber: 0,
    UI: "",
    barname: undefined,
    loading: true,
    count: 0,
    directTransaction: false,
  };

  async getData() {
    this.setState({ loading: true });

    const params = {
      numberpage: this.state.pageNumber || 1,
      numberitems: this.state.showNumber || 10,
      barname: this.state.barname || undefined,
      directTransaction: this.state.directTransaction ? 1 : undefined,
      startDate: this.state.startDate || undefined,
      endDate: this.state.endDate || undefined,
    };

    const datas = await getRequestByAuth("/wallet/v1/all", params);

    if (datas && datas.status === 200) {
      this.setState({
        UI: datas.data.UI,
        users: datas.data.all,
        paginationlength: datas.data.number,
        startNumber: (this.state.pageNumber - 1) * this.state.showNumber + 1,
        count: datas.data.count,
      });
    }

    this.setState({ loading: false });
  }

  setInputNumber = event => {
    this.setState({ showNumber: event.target.value, pageNumber: 1 });
  };

  setInput = event => {
    this.setState({ searchText: event.target.value, pageNumber: 1 }, () => {
      this.getData();
    });
  };

  changePageNumber(number) {
    this.setState({ pageNumber: number, active: number }, () => {
      this.getData();
    });
  }

  componentDidMount() {
    this.getData();
  }

  componentDidUpdate(prevProps, prevState) {
    const showNumber = this.state.showNumber !== prevState.showNumber;
    const pageNumber = this.state.pageNumber !== prevState.pageNumber;

    if (showNumber || pageNumber) {
      this.getData();
    }
  }

  paginationClicked = event => {
    const itemClicked = event.target.text;
    this.setState({ pageNumber: itemClicked, active: itemClicked }, () => {
      this.getData();
    });
  };

  render() {
    const table = (
      <div className="w-100 px-1 overflow-x-auto">
        <Table
          responsive
          striped
          bordered={true}
          style={{ fontFamily: "iran" }}
        >
          <thead>
            <tr className="align-middle text-center">
              <th className="text-center">#</th>
              <th className="text-center">شماره بارنامه</th>
              <th className="text-center">واریز/برداشت</th>
              <th className="text-center">مبلغ</th>
              <th className="text-center">موجودی</th>
              <th className="text-center">مبلغ بلوکه شده</th>
              <th className="text-center">وضعیت</th>
              <th className="text-center">پیام</th>
              <th className="text-center">شماره تراکنش</th>
              <th className="text-center">تاریخ</th>
            </tr>
          </thead>
          <tbody>
            {this.state.loading === true && (
              <tr className="text-center">
                <td colSpan={10}>
                  <Laoding />
                </td>
              </tr>
            )}
            {this.state.loading === false &&
              this.state.users?.map((user, index) => (
                <tr key={index} className="align-middle">
                  <td className="text-center">
                    {index + this.state.startNumber}
                  </td>
                  <td className="text-center">
                    <PrintLink ids={[user.item.numberParcel]} byNumberParcel>
                      {user.item.numberParcel}
                    </PrintLink>
                  </td>
                  <td className="text-center">{user.item.type}</td>
                  <td>
                    <p className="ltr mb-0 text-center">
                      {user.item.amount.toLocaleString()}
                    </p>
                  </td>
                  <td>
                    <p className="ltr mb-0 text-center">
                      {user.item.cash.toLocaleString()}
                    </p>
                  </td>
                  <td className="text-center">{user.item.blockAmount}</td>
                  <td className="text-center">{user.item.status}</td>
                  <td className="text-center">{user.item.description}</td>
                  <td className="text-center">{user.item.trackingCode}</td>
                  <td className="text-center">
                    {user.date} - {user.time}
                  </td>
                </tr>
              ))}
          </tbody>
        </Table>
      </div>
    );

    const optionArew = (
      <form
        onSubmit={e => {
          e.preventDefault();
          if (this.state.pageNumber === 1) this.getData();
          else this.setState({ pageNumber: 1 });
        }}
      >
        <div className="d-flex flex-wrap my-3">
          <Col xs={12} sm={6} lg={4} xl={3} className="px-1">
            <Form.Label>تعداد نمایش:</Form.Label>
            <Form.Select id="disabledSelect" onChange={this.setInputNumber}>
              <option>10</option>
              <option>20</option>
              <option>50</option>
              <option>100</option>
            </Form.Select>
          </Col>

          <Col xs={12} sm={6} lg={4} xl={3} className="px-1">
            <Form.Label>شماره سفارش:</Form.Label>
            <Form.Control
              type="number"
              onChange={e => {
                const number = e.target.value;
                this.setState({
                  barname:
                    isNaN(number) || !number ? undefined : parseInt(number),
                });
              }}
            />
          </Col>

          <Col
            xs={12}
            sm={6}
            lg={4}
            className="d-flex column-gap-2 align-items-center border rounded-2 mt-4 p-2"
          >
            <Form.Check
              id="direct-transaction-wallet"
              className={styles.check}
              onChange={e =>
                this.setState({ directTransaction: e.target.checked })
              }
            />
            <Form.Label
              htmlFor="direct-transaction-wallet"
              className="user-select-none c-pointer mb-0"
            >
              تراکنش های مستقیم
            </Form.Label>
          </Col>

          <div className="w-100 d-flex flex-wrap row-gap-2">
            <Col xs={12} sm={6} lg={4} xl={3} className="ps-1">
              <DateFilter
                label="از تاریخ:"
                onChange={date => this.setState({ startDate: date })}
              />
            </Col>

            <Col xs={12} sm={6} lg={4} xl={3} className="pe-1">
              <DateFilter
                label="تا تاریخ:"
                onChange={date => this.setState({ endDate: date })}
              />
            </Col>
          </div>

          <Col xs={12} className="mt-2 px-1">
            <Button type="sumbit">جستجو</Button>
          </Col>
        </div>
      </form>
    );

    const paginate = (
      <div className="my-3">
        <PaginateCard
          numberItems={this.state.showNumber}
          numberPage={this.state.pageNumber}
          onIndexChoose={number => {
            this.setState({ pageNumber: number });
          }}
          count={this.state.count}
        />
      </div>
    );

    return (
      <Container>
        {optionArew}
        {table}
        {paginate}

        <ExcelDownload
          label="دانلود فایل اکسل"
          config={{
            url: "/wallet/v1/all",
            params: {
              isExcel: true,
              barname: this.state.barname || undefined,
              directTransaction: this.state.directTransaction || undefined,
              startDate: this.state.startDate || undefined,
              endDate: this.state.endDate || undefined,
            },
          }}
        />
      </Container>
    );
  }
}
